{
  "dashboard": {
    "column": {
      "title": "Titel",
      "todo": "Att göra"
    },
    "header": "Kontrollpanel",
    "myTodos": {
      "title": "Mina uppgifter",
      "itemsCount": "{{count}} uppgifter",
      "empty": "Inga uppgifter just nu",
      "tooltips": {
        "reviewStep": "Du har ett dokument att granska",
        "approveStep": "Du har ett dokument att godkänna",
        "publishDocument": "Arbetsflöde klart, redo att publicera",
        "rejectedStepByUser": "{{name}} avvisade ett steg i arbetsflödet",
        "rejectedStepByYou": "Du avvisade ett steg i arbetsflödet",
        "rejectedStepFallback": "Ett steg i arbetsflödet avvisades",
        "moveForward": "Steg klart, nästa steg kan aktiveras",
        "readDocument": "Du har ett dokument att läsa",
        "takeQuiz": "Du har ett quiz att göra"
      },
      "dateLabels": {
        "published": "Publicerad",
        "adopted": "Beslutad",
        "created": "Skapad",
        "date": "Datum",
        "stepDueAt": "Stegets svarsdatum",
        "documentVersionReviewTo": "Planerat slutdatum"
      }
    },
    "ongoing": {
      "workflows": "Pågående arbetsflöden"
    },
    "publish": {
      "title": "Förankring"
    },
    "pinnedDocuments": {
      "title": "Fastnålade dokument",
      "addTitle": "Nåla fast dokument",
      "addDescription": "Dokumentet kommer att visas på kontrollpanelen för samtliga användare som har åtkomst till det",
      "editTitle": "Redigera fastnålat dokument",
      "editDescription": "Uppdatera beskrivningen på kontrollpanelen för \"{{title}}\"",
      "document": "Dokument",
      "documentPlaceholder": "Välj dokument",
      "description": "Kort beskrivning",
      "descriptionPlaceholder": "Skriv en kort beskrivning för kontrollpanelen",
      "removeDialog": {
        "title": "Ta bort fastnålat dokument",
        "description": "Ta bort \"{{title}}\" från fastnålade dokument?",
        "button": "Ta bort"
      },
      "toasts": {
        "added": "Dokumentet har nålats fast",
        "updated": "Det fastnålade dokumentet har uppdaterats",
        "removed": "Det fastnålade dokumentet har tagits bort",
        "removing": "Tar bort det fastnålade dokumentet..."
      }
    },
    "upcoming": {
      "workflows": "Kommande arbetsflöden"
    },
    "createDocument": {
      "uploadFile": "Ladda upp fil",
      "file": "Fil",
      "fileType": "Typ",
      "fileTypeDescription": "Vänligen notera att redigering av Office-dokument kräver en aktiv Microsoft 365-licens",
      "supportedFormats": "Filformat som stöds:",
      "errorCreating": "Fel vid skapande av dokument"
    },
    "userManual": {
      "getStarted": "Kom igång med North House genom att läsa",
      "userGuide": "Användarguiden"
    }
  }
}
